import { render, staticRenderFns } from "./OrthoViewer.vue?vue&type=template&id=45194cda&scoped=true"
import script from "./OrthoViewer.vue?vue&type=script&lang=ts"
export * from "./OrthoViewer.vue?vue&type=script&lang=ts"
import style0 from "./OrthoViewer.vue?vue&type=style&index=0&id=45194cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45194cda",
  null
  
)

export default component.exports